import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite/no-important';

import Content from './Content';
import PositionCard from './PositionCard';
import StyleUtils from './StyleUtils';

class HomePage extends Component {
  componentDidMount() {
    document.title = 'Join The Michigan Daily';
    this.scrollPage();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.locHash !== this.props.locHash) {
      this.scrollPage();
    }
  }

  scrollPage() {
    if (this.props.locHash === '') {
      window.scrollTo(0, 0);
    } else if (this.props.locHash === '#positions') {
      window.scroll({
        top: 657,
        left: 0,
        behavior: 'smooth',
      });
    } else if (this.props.locHash === '#contact') {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  render() {
    const bgIMG = "url('/tmd_recruit/IMG/building.jpg')";
    const bgIMGStyle = {
      backgroundImage: bgIMG,
    };

    const positionCards = Content.sections.map(section => (
      section.positions.map(position => (
        <PositionCard positionContent={position} sectionContent={section} />
      ))
    ));

    return (
      <div className="home-container">
        <div className="top-img-holder" style={bgIMGStyle}>
          <div className="top-shade" />
          <div className="top-content-holder">
            <h1>
              {'Applications For Fall 2018'}
              <br />
              {'are currently open'}
            </h1>
            <div className="apply-button-holder">
              <Link to="#positions">
                {'Apply Today'}
              </Link>
            </div>
          </div>
        </div>
        <div className={css(styles.homeBodyContent)}>
          <div>
            <h3 className={css(styles.contentTitle)}>
              {Content.about.title}
            </h3>
            <p>
              {Content.about.body}
            </p>
          </div>
          <div className={css(styles.positionsContainer)}>
            <h3 className={css(styles.contentTitle)}>
              {'Open Positions'}
            </h3>
            {positionCards}
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  contentTitle: {
    '@media (max-width: 535px)': {
      textAlign: 'center',
    },
    '@media (min-width: 536px) and (max-width: 1059px)': {
      textAlign: 'center',
    },
    fontFamily: 'Helvetica Neue, Helvetica, Open Sans, sans-serif',
    fontSize: 24,
    fontWeight: 500,
    margin: '25px 0px 0px 0px',
  },
  applyButton: {
    padding: '20px 65px 20px 65px',
    lineHeight: 30,
    backgroundColor: StyleUtils.tmdBlue,
    color: 'white',
    fontFamily: StyleUtils.mainFont,
    fontWeight: 400,
    textTransform: 'uppercase',
    border: `1px solid ${StyleUtils.tmdBlue}`,
    transition: StyleUtils.stdTransition,
    textDecoration: 'none',
    borderRadius: 5,
    height: 'auto',
    ':hover': {
      textDecoration: 'none',
      color: StyleUtils.tmdBlue,
      backgroundColor: 'white',
    },
  },
  applyButtonHolder: {
    // height: 150,
  },
  topContentText: {
    color: 'white',
    fontFamily: StyleUtils.titleFont,
    fontSize: 48,
    fontWeight: 300,
    marginBottom: 35,
  },
  topContentHolder: {
    position: 'absolute',
    textAlign: 'center',
    height: 'auto',
    marginTop: -20,
  },
  homeBodyContent: {
    maxWidth: 1024,
    margin: 'auto',
  },
  positionsContainer: {
    paddingBottom: 40,
    overflow: 'hidden',
  },
});

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.jsx